module.exports = __webpack_public_path__ + "media/bayonetta.6cf0cf69.wav";